import { useContext, useState } from "react"
import { any, bool, func, number, string } from "prop-types"
import { Checkbox } from "components/ui"
import { StackView } from "@planningcenter/tapestry-react"
import RegisterableContext from "components/admin/registerable/context"

const SignupTime = ({
  id,
  name,
  selected: initialSelected = false,
  onSelectionsChange,
  children,
  className
}) => {
  const { registerable } = useContext(RegisterableContext)
  const [selected, setSelected] = useState(initialSelected)

  const handleSignupTimeToggle = ({ target: { checked } }) => {
    setSelected(checked)

    if (!checked) {
      onSelectionsChange(
        registerable.attendeeTypeSelections
          .filter(({ signupTimeId }) => signupTimeId == id)
          .map(selection => ({
            id: selection.id,
            count: 0
          }))
      )
    }
  }

  return (
    <StackView className={className}>
      <Checkbox
        name={`signup-time-${id}`}
        htmlFor={`signup-time-${id}`}
        text={name}
        value={id.toString()}
        checked={selected}
        onSelect={handleSignupTimeToggle}
        wrapperClasses={`signupTime ${selected && "signupTimeChecked"}`}
      />
      {selected && <div className="signupTimeChildren">{children}</div>}
    </StackView>
  )
}

SignupTime.propTypes = {
  id: number.isRequired,
  name: string.isRequired,
  selected: bool,
  onSelectionsChange: func.isRequired,
  children: any,
  className: string
}

export default SignupTime
